<template lang="pug">
    div(v-if="currentUser" style="display: inline;")
        template(v-if="isManualMode")
            v-btn(
                v-if="newManualModeEnabled && !validCampaignCustomerActiveId"
                icon
                color="primary"
                small
                @click="openEditDialog();"
            )
                v-icon mdi-pencil
                
            v-btn.btn-margin-xs(
                color="primary"
                small
                @click="exit();"
            )
                | Exit Manual

        template(v-else)
            v-btn.btn-margin-xs(
                color="primary"
                :small="!isQueueSelection"
                :large="isQueueSelection"
                @click="reset(); dialog = true;"
            )
                | Manual Mode

        v-dialog(v-model='dialog' persistent max-width='600')

            v-card.manual-mode-card(elevation="8")
                v-card-title.headline.primary.white--text
                    v-icon(left) mdi-account-cog
                    template(v-if="!isManualMode") Enter Manual Mode
                    template(v-else) Edit Manual Mode Settings
                    v-spacer
                    v-btn(icon small style="color: white; width: 36px; height: 36px;" @click="handleCancel()")
                        v-icon(size="24" style="margin: 0; padding: 0;") mdi-close
                
                v-card-text.pt-4
                    v-alert.manual-default-alert(
                        v-if="defaultCampaignIdAvailable && !showCampaignSelection"
                        type="success"
                        :icon="false"
                        dense
                        text
                        outlined
                        style="display: flex; align-items: center; width: auto; min-width: unset; max-width: 100%; font-size: 13px; padding: 2px 16px 2px 8px; margin: 0 0 8px 0; vertical-align: middle;"
                    )
                        v-btn(
                            icon
                            small
                            color="primary"
                            style="margin-right: 8px;"
                            @click="showCampaignSelection = true"
                        )
                            v-icon mdi-pencil
                        span Using your saved default settings!
                    div(style="height: 24px;")
                    
                    template(v-if="!defaultCampaignIdAvailable || showCampaignSelection")
                        v-alert.manual-error-alert(
                            v-if="!isLoading && (!isQueueSelection || validCommunicationType) && organizationID > 0 && !validCampaigns"
                            dense
                            type='error'
                            outlined
                        )
                            | You have selected an organization without any campaigns that are eligible to be dialed on.

                        v-select.manual-communication-select(
                            v-if="isQueueSelection"
                            v-model='selectedCommunicationType'
                            :items='communicationTypes'
                            label='Communication Type'
                            item-text="key"
                            item-value="value"
                            dense
                            outlined
                            color="primary"
                            prepend-icon="mdi-phone-message"
                            @change="getLoggedInCampaigns();"
                        )

                        OrganizationSelect(
                            v-model='organizationID'
                            :organization-users='organizationUsers'
                            label='Please select an organization'
                            clearable
                            @change="getLoggedInCampaigns();"
                        )

                        v-autocomplete.manual-campaign-select(
                            :disabled="!(organizationID > 0 && validCampaigns)"
                            :items='campaigns'
                            item-text='campaign_name'
                            item-value='campaign_id'
                            label='Please select a logged in campaign'
                            v-model='campaignID'
                            dense
                            outlined
                            color="primary"
                            prepend-icon="mdi-target"
                        )                      
                            template(v-slot:item='data')
                                v-list-item-content
                                    v-list-item-title.font-weight-medium {{ data.item.organization_name }}
                                    v-list-item-subtitle.text-caption {{ data.item.campaign_name }}

                        v-checkbox.manual-enroll-checkbox(
                            v-if="isEligibleToRenderEnrollAsEligible"
                            v-model='enrollAsEligible'
                            label="Enroll customer for campaign attempts?"
                            color="primary"
                            dense
                        )
                
                    template(v-if="showCallNumberDialer && !isManualMode")
                        v-row(align="start" justify="space-between" no-gutters style="margin: 4px 0 0 0;")
                            v-select(
                                :items='countries'
                                :item-text="countryDisplay"
                                item-value="iso_two"
                                label='Country'
                                v-model="selectedCountry"
                                dense
                                outlined
                                color="primary"
                                style="flex: 0 0 15%; max-width: 15%; min-width: 60px; margin-right: 8px;"
                                class="manual-country-select"
                            )
                                template(v-slot:item='data')
                                    v-list-item-content
                                        v-list-item-title {{ data.item.name }} ({{ data.item.dialing_code }})
                            v-text-field(
                                v-model="outboundNumber"
                                label="Phone Number To Dial"
                                dense
                                outlined
                                color="primary"
                                :disabled="startDisabled"
                                style="flex: 1 1 80%; min-width: 0;"
                                class="manual-dialer-field"
                                :hint="outboundNumberType"
                                :error-messages="outboundNumberErrorMessage"
                                v-on:keypress="outboundNumberChange"
                            )
                                template(v-slot:append)
                                    v-tooltip(bottom)
                                        template(v-slot:activator="{ on, attrs }")
                                            span(v-bind="attrs" v-on="on")
                                                v-btn(
                                                    color="success"
                                                    icon
                                                    :disabled="startDisabled || !outboundNumberValid"
                                                    @click="start(true)"
                                                    class="dial-btn"
                                                )
                                                    v-icon mdi-phone-forward
                                        span Dial Number
                        v-row(align="center" justify="center" style="margin: 0 0 20px 0;")
                            span(style="color: #888; font-weight: 600; letter-spacing: 1px; font-size: 13px; white-space: nowrap; background: #fff; padding: 0 6px; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.03);") OR
                        v-btn.manual-start-btn(
                            color='success'
                            outlined
                            text
                            block
                            :disabled="startDisabled"
                            @click='start();'
                            style="height: 40px; font-size: 13px;"
                        )
                            v-icon(left) mdi-magnify
                            | Search Customers

                v-card-actions.pa-4(v-if="!showCallNumberDialer || isManualMode")
                    v-spacer
                    v-btn.manual-cancel-btn(
                        color='grey darken-1'
                        outlined
                        text
                        @click='handleCancel();'
                    )
                        v-icon(left) mdi-close
                        | Cancel
                    v-btn.manual-start-btn(
                        color='success'
                        outlined
                        text
                        :disabled="startDisabled"
                        @click='start();'
                    )
                        template(v-if="!isManualMode")
                            v-icon(left) mdi-play
                            | Start Manual Mode
                        template(v-else)
                            v-icon(left) mdi-content-save
                            | Save Settings

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Helpers
    import { cleanupPhoneNumber } from "@/helpers/phone_number";

    // Data
    import { GetLoggedInCampaigns, UpdateAccountUser } from "@/data";

    // Components
    import OrganizationSelect from '@/components/shared/organization_select.vue';

    export default Vue.extend({
        data() {
            return {
                campaignID: null,
                campaigns: [],
                communicationTypes: [],
                dialog: false,
                outboundNumber: null,
                enrollAsEligible: false, // currently only supported for phone enrollments since email and message are already enrolled as "return" enrollments
                errorMessage: null,
                isLoading: false,
                organizationID: null,
                outboundNumberErrorMessage: null,
                outboundNumberType: null,
                outboundNumberValid: false,
                selectedCommunicationType: null,
                selectedCountry: "US",
                showCampaignSelection: false,
                validatedOutboundNumber: null,
                hasBeenOpenedByProp: false,
            }
        },
        methods: {
            countryDisplay(item) {
                return item?.dialing_code;
            },
            buildCommunicationTypes() {

                // Init
                this.communicationTypes = [];         

                // Email
                if (this.hasEmailScreenEnabled){
                    this.communicationTypes.push({ key: "Email", value: "email" });
                }

                // Phone
                if (this.hasCallScreenEnabled) {
                    this.communicationTypes.push({ key: "Phone", value: "phone" });
                }

                // // SMS message
                // if (this.hasMessageScreenEnabled) {
                //     this.communicationTypes.push({ key: "SMS Message", value: "sms_message" });
                // }
            },
            exit() {
                this.reset();
                this.exitManualMode();
            },
            openEditDialog() {
                // Set current values for editing
                if (this.isQueueSelection) {
                    this.selectedCommunicationType = this.currentUser?.account_user?.manual_mode_default_communication_type;
                }
                this.organizationID = this.currentUser?.account_user?.manual_mode_default_organization_id;
                this.campaignID = this.currentUser?.account_user?.manual_mode_default_campaign_id;
                
                // Load campaigns for the selected organization
                if (this.organizationID > 0) {
                    this.getLoggedInCampaigns();
                }
                
                // Open dialog
                this.showCampaignSelection = true;
                this.dialog = true;
            },
            getLoggedInCampaigns() {

                // reset campaign data
                this.campaignID = null;
                this.campaigns  = [];

                // No need to run request if we already know that we are not logged into any queues
                if (!this.hasLoggedInQueues) {
                    this.errorMessage = "You are not currently logged into any campaigns. Please log into some queues to get started.";
                    if (!this.showCampaignSelection) {
                        this.showCampaignSelection = true;
                    }
                    return;
                }

                if (this.isQueueSelection && !this.validCommunicationType) {
                    this.errorMessage = "Please select a communication type to search campaigns.";
                    if (!this.showCampaignSelection) {
                        this.showCampaignSelection = true;
                    }
                    return;
                }

                if (!(this.organizationID > 0)) {
                    this.errorMessage = "Please select an organization to search campaigns.";
                    if (!this.showCampaignSelection) {
                        this.showCampaignSelection = true;
                    }
                    return;
                }

                // Init
                const options = {
                    communication_type: (this.selectedCommunicationType || ""),
                    is_eligible_to_dial: true,
                    organization_id: this.organizationID,
                }
                // Set loader
                this.isLoading = true;
                GetLoggedInCampaigns(this.currentUser?.user_id, options).then((response) => {
                    if (response?.Data?.campaigns?.length > 0) {
                        this.campaigns = response.Data.campaigns;
                        this.errorMessage = null;
                        if (this.defaultCampaignIdAvailable) {
                            const defaultCampaignId = this.currentUser?.account_user?.manual_mode_default_campaign_id;
                            const campaignExists = this.campaigns.some(campaign => campaign.campaign_id === defaultCampaignId);
                            if (campaignExists) {
                                this.campaignID = defaultCampaignId;
                            } else {
                                this.errorMessage = "You are not logged into any campaigns that are eligible to be dialed on.";
                                if (!this.showCampaignSelection) {
                                    this.showCampaignSelection = true;
                                }
                            }
                        }
                    } else {
                        this.errorMessage = "You are not logged into any campaigns that are eligible to be dialed on.";
                        if (!this.showCampaignSelection) {
                            this.showCampaignSelection = true;
                        }
                    }
                    this.isLoading = false;
                });
            },
            handleCancel() {
                this.dialog = false;
                this.selectedCountry = "US";
                this.outboundNumber = null;
                this.showCampaignSelection = false;
            },
            outboundNumberChange(e) {
                // Ensure only numbers are entered
                if (isNaN(e.key)) {
                    e.preventDefault();
                }
            },
            reset() {
                // Only reset to null if we don't have default values
                if (!this.defaultCampaignIdAvailable) {
                    this.campaignID = null;
                    this.campaigns = [];
                    this.errorMessage = null;
                    this.organizationID = null;
                    this.selectedCommunicationType = null;
                } else {
                    // Set the default values
                    if (this.isQueueSelection) {
                        this.selectedCommunicationType = this.currentUser?.account_user?.manual_mode_default_communication_type;
                    }
                    this.organizationID = this.currentUser?.account_user?.manual_mode_default_organization_id;
                    this.getLoggedInCampaigns();
                    // Then set the value after a small delay to ensure the field is set after the dialog is opened
                    this.$nextTick(() => {
                        if (this.renderEnrollAsEligible) {
                            if (this.accountDefaultsTrueForEnrollAsEligible) {
                                this.enrollAsEligible = true;
                            } else {
                                this.enrollAsEligible = this.currentUser?.account_user?.manual_mode_default_enroll_as_eligible || false;
                            }
                        }
                    });
                }
            },
            start(dialNumber = false) {

                // Verify
                if (!this.campaignID || !(this.campaigns?.length > 0)) {
                    return;
                }

                // Update account user with new defaults
                this.updateAccountUser();

                // Find campaign by index
                const idx = this.campaigns.findIndex(i => i.campaign_id === this.campaignID);
                if (idx < 0) {
                    return;
                }

                // Validate we have a valid outbound number if using that option
                if (dialNumber && !this.outboundNumberValid) {
                    return;
                }

                // If they typed something but decided to search, don't auto dial out
                if (!dialNumber) {
                    this.validatedOutboundNumber = null;
                }

                // Close modal
                this.dialog = false;

                // Enter manual mode
                this.enterManualMode(this.campaigns[idx], this.selectedCommunicationType, this.enrollAsEligible, null, this.validatedOutboundNumber);
            },
            updateAccountUser() {
                const options = {
                    manual_mode_default_communication_type: this.selectedCommunicationType,
                    manual_mode_default_organization_id: this.organizationID,
                    manual_mode_default_campaign_id: this.campaignID,
                    manual_mode_default_enroll_as_eligible: this.enrollAsEligible,
                }

                // Only places we enter using the component buttons are queue selection and call screen
                if (!this.isQueueSelection) {
                    options.manual_mode_default_communication_type = "phone";
                }

                if (!this.currentUser?.account_user?.account_user_id) {
                    return;
                }

                // Update account user
                UpdateAccountUser(this.currentUser.account_user.account_user_id, options)
            },
            validateOutboundNumber() {
                if (this.outboundNumber?.length > 0) {
                    const cleanPN = cleanupPhoneNumber(this.outboundNumber, this.selectedCountry);
                    this.outboundNumberErrorMessage = cleanPN.valid === true ? null : "Please enter a valid phone number";
                    this.outboundNumberType = cleanPN.valid === true ? cleanPN.numberType[0].toUpperCase() + cleanPN.numberType.slice(1) : null;
                    this.outboundNumberValid = cleanPN.valid === true;
                    this.validatedOutboundNumber = cleanPN.valid === true ? cleanPN.phoneNumber : null;
                } else {
                    this.outboundNumberErrorMessage = null;
                    this.outboundNumberType = null;
                    this.validatedOutboundNumber = null;
                }
            },
            openDialogFromProp() {
                if (this.openManualMode && !this.dialog) {
                    this.dialog = true;
                }
            },
        },
        computed: {
            countries() {
                return VolieState.countries();
            },
            currentUser() {
                return VolieState.currentUser();
            },
            newManualModeEnabled() {
                return this.currentUser?.account?.new_manual_mode_enabled === true;
            },
            accountDefaultsTrueForEnrollAsEligible() {
                return this.currentUser?.account?.default_enroll_manual_mode === true;
            },
            defaultCampaignIdAvailable() {
                if (!this.newManualModeEnabled) {
                    return false;
                }
                const accountUser = this.currentUser?.account_user;
                if (!accountUser) {
                    return false;
                }
                return accountUser.manual_mode_default_campaign_id > 0 && accountUser.manual_mode_default_communication_type?.length > 0 && accountUser.manual_mode_default_organization_id > 0;
            },
            hasCallScreenEnabled() {
                return this.currentUser?.account?.communication_center_call_enabled === true;
            },
            hasEmailScreenEnabled() {
                return this.currentUser?.account?.communication_center_email_enabled === true;
            },
            hasMessageScreenEnabled() {
                return this.currentUser?.account?.communication_center_message_enabled === true;
            },
            isEligibleToRenderEnrollAsEligible() {
                return this.renderEnrollAsEligible && (this.isSelectedCommunicationTypePhone || (!this.validCommunicationType && !this.isQueueSelection));
            },
            isSelectedCommunicationTypePhone() {
                return this.selectedCommunicationType === "phone";
            },
            startDisabled() {

                // Ensure campaign ID
                if (!this.campaignID) {
                    return true;
                }

                // If queue selection, need a communication type
                if (this.isQueueSelection === true && !this.selectedCommunicationType) {
                    return true;
                }

                return false;
            },
            showCallNumberDialer() {
                return this.defaultCampaignIdAvailable && (this.selectedCommunicationType === 'phone' || !this.isQueueSelection);
            },
            validCampaigns() {
                return this.campaigns?.length > 0;
            },
            validCommunicationType() {
                return this.selectedCommunicationType?.length > 0;
            },
        },
        components: {
            OrganizationSelect,
        },
        props: {
            enterManualMode: Function,
            exitManualMode: Function,
            hasLoggedInQueues: Boolean,
            isManualMode: Boolean,
            isQueueSelection: Boolean,
            openManualMode: Boolean,
            organizationUsers: Array,
            renderEnrollAsEligible: Boolean,
            validCampaignCustomerActiveId: Boolean,
        },
        created() {
            this.buildCommunicationTypes();
        },
        watch: {
            selectedCommunicationType() {
                this.enrollAsEligible = false; // change back to false if communication type is changed
            },
            "outboundNumber"() {
                this.validateOutboundNumber();
            },
            "openManualMode": {
                immediate: true,
                handler(newVal, oldVal) {
                    if (newVal === true && !this.hasBeenOpenedByProp && !this.dialog) {
                        this.reset();
                        this.dialog = true;
                        this.hasBeenOpenedByProp = true;
                    }
                }
            },
        },
    });
</script>

<style lang="scss" scoped>
.btn-margin-xs {
    margin: 4px 4px 4px 4px !important;
}

.manual-mode-card {
    border-radius: 12px !important;
    overflow: hidden;
    .v-card__title {
        background: #035b99;
        padding: 20px 24px;
        .v-icon {
            margin-right: 8px;
        }
    }
}

.manual-settings-switch {
    margin-bottom: 16px;
    .v-input__slot {
        background-color: #f5f5f5;
        border-radius: 8px;
    }
}

.manual-default-alert {
    border-radius: 8px;
    margin-bottom: 16px;
    .v-icon {
        color: #4caf50;
    }
}

.manual-error-alert {
    border-radius: 8px;
    margin-bottom: 16px;
    .v-icon {
        color: #f44336;
    }
}

.manual-communication-select,
.manual-org-select,
.manual-campaign-select {
    margin-bottom: 16px;
    .v-input__slot {
        border-radius: 8px;
        transition: all 0.3s ease;
        &:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
    }
    .v-input__prepend-outer {
        margin-right: 8px;
    }
}

.manual-enroll-checkbox {
    margin-top: 8px;
    margin-bottom: 16px;
    .v-input__slot {
        background-color: #f5f5f5;
        border-radius: 6px;
        padding: 8px 12px;
    }
}

.manual-cancel-btn,
.manual-start-btn {
    border-radius: 8px !important;
    font-weight: 600;
    text-transform: none;
    letter-spacing: 0.5px;
    padding: 12px 24px;
    transition: all 0.3s ease;
    &:hover:not(:disabled) {
        transform: translateY(-1px);
    }
    &:disabled {
        opacity: 0.6;
    }
}

.manual-start-btn {
    &:not(:disabled):hover {
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
    }
}

.manual-cancel-btn {
    &:hover {
        box-shadow: 0 4px 12px rgba(158, 158, 158, 0.3) !important;
    }
}

.font-weight-medium {
    font-weight: 500;
}

.text-caption {
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.6);
}

.manual-country-select {
    .v-input__slot {
        border-radius: 8px;
        transition: all 0.3s ease;
        &:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
    }
    .v-input__prepend-outer {
        margin-right: 8px;
    }
}

.manual-dialer-field ::v-deep(.v-input__append-outer) {
    display: flex;
    align-items: center;
    height: 100%;
}

.dial-btn {
    margin-top: -8px;
    height: 36px;
    width: 36px;
}

.manual-or-align {
    position: relative;
    top: 10px !important;
}
.manual-btn-align {
    position: relative;
    top: 0px !important;
}
</style>
